import { Auth as aws } from 'aws-amplify'
import { useAuthStore } from 'shared/store/authSlice'

export const checkIsLoggedIn = async () => {
  const { logIn, logOut } = useAuthStore.getState()
  try {
    const currentUser = await aws.currentAuthenticatedUser({ bypassCache: true })
    if (Boolean(currentUser)) {
      logIn()
    } else {
      logOut()
    }
  } catch (e) {
    logOut()
  }
}
